<div class="modal-header">
  <h4 class="modal-title">{{'editProjectVersionPopup.title' | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p>{{'editProjectVersionPopup.message' | translate}}</p>
    <form [formGroup]="form">
      <div class="mb-3 row mb-5">
        <label class="col-md-6 col-form-label">{{'editProjectVersionPopup.label.project_version' | translate}}: *</label>
        <div class="col-md-6">
          <input type="text"
                 class="form-control"
                 id="projectVersion"
                 spellcheck="false"
                 [class.is-invalid]="!form.controls.projectVersion.valid && form.controls.projectVersion.touched"
                 formControlName="projectVersion"
                 (keydown.enter)="continue()"
                 appInputAutoFocus autofocus>
          <div class="invalid-feedback">{{form.controls.projectVersion.errors?.messageKey | translate: {'0': form.controls.projectVersion.errors?.param} }}</div>
        </div>
      </div>
      <p>{{ 'editProjectVersionPopup.label.project_note' | translate }}</p>
      <div class="mb-3 row">
        <label class="col-md-6 col-form-label">{{'confNameComponent.label.configuration_name' | translate}}: *</label>
        <div class="col-md-6">
          <input type="text"
                 class="form-control"
                 id="projectName"
                 spellcheck="false"
                 [class.is-invalid]="!form.controls.projectName.valid && form.controls.projectName.touched"
                 formControlName="projectName"
                 (keydown.enter)="continue()">
          <div class="invalid-feedback">{{form.controls.projectName.errors?.messageKey | translate: {'0': form.controls.projectName.errors?.param} }}</div>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-6 col-form-label">{{'confNameComponent.label.creator' | translate}}</label>
        <div class="col-md-6">
          <input type="text"
                  class="form-control"
                  spellcheck="false"
                  [(ngModel)]="creator"
                  [ngModelOptions]="{standalone: true}"
                  (keydown.enter)="continue()">
        </div>
      </div>
      <div class="mb-3 row mb-4">
        <label class="col-md-6 col-form-label">{{'confNameComponent.label.customer_material_number' | translate}}</label>
        <div class="col-md-6">
          <input type="text"
                  formControlName="projectCustomerMaterialNumber"
                  [class.is-invalid]="!form.controls.projectCustomerMaterialNumber.valid && form.controls.projectCustomerMaterialNumber.touched"
                  class="form-control"
                  spellcheck="false"
                  [placeholder]="this.getTrimmedCustomerMaterialNumber(this.form.controls.projectName.value)"
                  (keydown.enter)="continue()">
          <div class="invalid-feedback">{{form.controls.projectCustomerMaterialNumber.errors?.messageKey | translate: {'0': form.controls.projectCustomerMaterialNumber.errors?.param} }}</div>
        </div>
      </div>
    </form>
    <p><b>{{'editProjectVersionPopup.notice_header' | translate}}</b><br>
    {{'editProjectVersionPopup.notice' | translate}}</p>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button id="step_forward" [disabled]="form.invalid" type="button" class="btn btn-primary btn-forward" (click)="continue()">{{'global.label.next' | translate}}</button>
</div>
